import React from 'react';

import { LoadingButton } from '@mui/lab';
import { Typography } from '@mui/material';
import { SaveSheet } from 'src/common/types/SaveSheet';
import { useExportPdf } from 'src/florence/hooks/useExportPdf';

type Props = {
  isDisabled: boolean;
  note: SaveSheet;
};

const ExportButton: React.FC<Props> = ({ isDisabled, note }) => {
  const { exportPdf, exportIsLoading } = useExportPdf();

  return (
    <LoadingButton
      loading={exportIsLoading}
      disabled={isDisabled}
      onClick={() => exportPdf(note)}
      variant='outlined'
      color='darkBlue'
      sx={{
        borderRadius: '40px',
        height: '40px',
        padding: '0 16px',
      }}
    >
      <Typography>Export</Typography>
    </LoadingButton>
  );
};

export default ExportButton;
